import { localStore } from '@/services/local.storage';
export default function guest ({ next, store }){
    if(store.getters.auth.loggedIn){
        if(atob(localStore.getLocalStorage('role')) != 'agent' || atob(localStore.getLocalStorage('role')) !=' vendor')
            return next({  name: 'Admin Dashboard'  })
        else if(atob(localStore.getLocalStorage('role'))=='agent')
            return next({  name: 'Agent Dashboard'  })
        else if(atob(localStore.getLocalStorage('role'))=='vendor')
            return next({  name: 'Vendor Dashboard'  })
    }

    return next()
}